import { render, staticRenderFns } from "./receiveScan.vue?vue&type=template&id=0edccf56&scoped=true"
import script from "./receiveScan.vue?vue&type=script&lang=js"
export * from "./receiveScan.vue?vue&type=script&lang=js"
import style0 from "./receiveScan.vue?vue&type=style&index=0&id=0edccf56&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edccf56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edccf56')) {
      api.createRecord('0edccf56', component.options)
    } else {
      api.reload('0edccf56', component.options)
    }
    module.hot.accept("./receiveScan.vue?vue&type=template&id=0edccf56&scoped=true", function () {
      api.rerender('0edccf56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/receiveScan.vue"
export default component.exports